import styled from "styled-components";
import { fadeIn } from "../Common/CommonStyles";

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const ModalContainer = styled.div`
  width: auto;
  height: auto;
  max-width: 2000px;
  background-color: #fff;
  border-radius: 5px;
  padding: 1rem;
  text-align: center;
  position: relative;

  @media screen and (min-width: 844px) {
    width: 70%;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background-color: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
`;

export const ConfirmationModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
`;

export const ConfirmationModalContainer = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 30px;
  min-width: 450px;
  max-width: 90%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  position: relative;
  animation: ${fadeIn} 0.3s ease-in;

  @media (max-width: 768px) {
    min-width: 320px;
    padding: 20px;
    margin: 20px;
  }
`;

export const ConfirmationModalContent = styled.div`
  text-align: center;
`;

export const ConfirmationModalButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 20px;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const FormModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
  overflow-y: auto;
  padding: 20px 0;
`;

export const FormModalContainer = styled.div`
  background-color: #fff;
  border-radius: 12px;
  padding: 0;
  min-width: 600px;
  max-width: 95%;
  max-height: 95vh;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  position: relative;
  animation: ${fadeIn} 0.3s ease-in;
  overflow-y: auto;

  @media (max-width: 768px) {
    min-width: 320px;
    margin: 10px;
    max-height: 90vh;
  }
`;

export const FormModalHeader = styled.div`
  background-color: #f8f9fa;
  padding: 20px 30px;
  border-bottom: 1px solid #e9ecef;
  border-radius: 12px 12px 0 0;
  position: relative;
`;

export const FormModalTitle = styled.div`
  text-align: center;
  margin: 0;
`;

export const FormModalCloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6c757d;
  padding: 5px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: #e9ecef;
    color: #495057;
  }
`;

export const FormModalContent = styled.div`
  padding: 30px;
  max-height: calc(95vh - 120px);
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 20px;
    max-height: calc(90vh - 100px);
  }
`;